import { render, staticRenderFns } from "./AddAttributeForm.vue?vue&type=template&id=3988ea8c&"
import script from "./AddAttributeForm.vue?vue&type=script&lang=js&"
export * from "./AddAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./AddAttributeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports